import { useQuery, QueryFunction } from '@tanstack/react-query'
import { useFetchWithAuth } from '../session/useFetchWithAuth'

const URL = import.meta.env.VITE_EPC_API_URL ?? ''

// Extended profile interface with admin-specific fields
export interface AdminProfileDetail {
  id: string
  emailAddress?: string
  color?: string
  firstName?: string
  lastName?: string
  avatarUrl?: string
  about?: string
  status?: string
  role?: string
  invitationUrl?: string
  createdAt?: string
  approvedBy?: string
  approvedAt?: string
  connectionPreference?: string
  secondaryLanguages?: string[]
  gradeLevels?: string[]
  contentAreas?: string[]
  schoolName?: string
  districtName?: string
  jobField?: string
  companyName?: string
  preferredActivities?: string[]
  cities?: string[]
  matches?: Array<{
    id: string
    matchScore?: number
    matchedProfileId: string
    matchedProfileFirstName?: string
    matchedProfileLastName?: string
    matchedProfileColor?: string
    matchedProfileAvatarUrl?: string
  }>
}

export const useAdminProfileById = (profileId?: string) => {
  const fetchWithAuth = useFetchWithAuth()

  const getProfileById: QueryFunction<AdminProfileDetail> = async () => {
    if (!profileId) {
      throw new Error('Profile ID is required')
    }

    try {
      const responseData = await fetchWithAuth(`${URL}/profile/${profileId}`, {
        method: 'GET',
      })
      return responseData
    } catch (error) {
      console.error('Error fetching admin profile by ID:', error)
      throw error
    }
  }

  return useQuery({
    queryKey: ['profile', profileId] as const,
    queryFn: getProfileById,
    retry: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
    enabled: !!profileId && profileId.length > 0,
  })
}
